import { AiOutlineCaretDown } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Dropdown = ({ values, open }) => {
  const { t } = useTranslation();
  return (
    <div>
      <span>
        <AiOutlineCaretDown />
      </span>
      <ul
        className={`bg-white absolute top-10 right-0 rounded-xl w-52 overflow-hidden z-20 ${
          open ? "block" : "hidden"
        }`}
      >
        {values.map((item, i) => {
          return (
            <Link to={item.route} key={i}>
              <li className="text-black p-2 hover:bg-hoverGray">
                {t(item.value)}
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default Dropdown;
